import React from 'react'
import Header from '../../header'
import iconsquare from '../../assets/images/icon-square.png'
class Designs extends React.Component{
    constructor(props)
    {
        super(props)
        {
            this.state={

            }
        }
        this.designback=this.designback.bind(this);
        this.Vinylheattransfer = this.Vinylheattransfer.bind(this);
        this.Irononpatches = this.Irononpatches.bind(this);
        this.Handheldgun  =this.Handheldgun.bind(this);
        this.designext = this.designext.bind(this);
    }
    designback()
    {
        this.props.history.push('/tshirt-selection')
    }
    designext()
    {
        this.props.history.push('/vinyl-heat-transfer');
    }
    Vinylheattransfer()
    {
        this.props.history.push('/vinyl-heat-transfer')
    }
    Irononpatches()
    {
        this.props.history.push('/iron-on-patches')
    }
    Handheldgun()
    {
        this.props.history.push('/hand-held-gun')
    }
    render()
    {
        let store = sessionStorage.getItem('store')
        return(
            <div>
                <Header/>
                <section className="home-register-section">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12 col-lg-12">
                                <div className="home-register-form-div design-menu-sec">
                                    <form>
                                    <div className="form-logo-section sec-center">
                                        <a href={'#/' + store}><img src={iconsquare} alt="logo" className="img-fluid brand-logo"/></a>
                                    </div>
                                    <h3>LOOKBOOK</h3>
                                    <div className="col-md-12 sec-center left">
                                        <div className="design-menu-inner">
                                            <ul>
                                                <li><button onClick={this.Vinylheattransfer}>VINYL HEAT TRANSFER</button></li>
                                                <li><button onClick={this.Irononpatches}>IRON ON PATCHES</button></li>
                                                <li><button onClick={this.Handheldgun}>HAND HELD INKJET GUN</button></li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* <div className="col-md-12 sec-center left">
                                        <div className="footer-btn"> 
                                            <div className="footer-left-btn"> 
                                                <button className="black_btn" onClick={this.designback}>Back</button>
                                            </div>
	                                    <div className="footer-right-btn"> 
                                            <button className="black_btn" onClick={this.designext}>Next</button>
	                                    </div>
	                                    </div>
                                    </div> */}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
export default Designs;